import { render, staticRenderFns } from "./StepResume.vue?vue&type=template&id=24c80902&scoped=true&"
import script from "./StepResume.vue?vue&type=script&lang=js&"
export * from "./StepResume.vue?vue&type=script&lang=js&"
import style0 from "./StepResume.vue?vue&type=style&index=0&id=24c80902&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c80902",
  null
  
)

export default component.exports